import { RefObject, useCallback, useState } from 'react'

type UseContextMenu = {
  sliderContainerRef: RefObject<HTMLDivElement>,
  disabledCtrls: boolean
  clipMarkers: {
    markIn: number | null
    markOut: number | null
  }
}

export const useContextMenu = ({ sliderContainerRef, disabledCtrls, clipMarkers }: UseContextMenu) => {
  const [ menuCoords, setMenuCoords ] = useState({ left: 0, top: 0 })
  const [ anchorEl, setAnchorEl ] = useState<HTMLDivElement | null>(null)
  const onOpenMenu = useCallback((e: MouseEvent) => {
    if (anchorEl || disabledCtrls || (!clipMarkers.markIn && !clipMarkers.markOut)) return
    e.preventDefault()
    e.stopPropagation()
    setMenuCoords({ left: e.clientX, top: e.clientY })
    setAnchorEl(sliderContainerRef.current)
  }, [ anchorEl, sliderContainerRef, disabledCtrls, clipMarkers ])

  const onCloseMenu = useCallback((e?: React.SyntheticEvent) => {
    e?.stopPropagation()
    setAnchorEl(null)
    setMenuCoords({ left: 0, top: 0 })
  }, [])

  return {
    onCloseMenu,
    onOpenMenu,
    anchorEl,
    menuCoords,
  }
}
